export default "__VITE_ASSET__C2NMIH_P__"